import api from './../../api/apiPortfolio'
import actions from './portfolioActions'

// Получение списка групп оператора
export const getGroups = () => async (dispatch: any) => {
    const responce = await api.getGroups()

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setGroups(responce.data.itemsData))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Получение списка студентов
export const getStudents = (groupOID: string) => async (dispatch: any) => {
    const responce = await api.getStudents(groupOID)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setStudents(responce.data.itemsData))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Получение списка файлов
export const getFiles = (studentID: string) => async (dispatch: any) => {
    const responce = await api.getFiles(studentID)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setFiles(responce.data.itemsData))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Загрузка файлов Портфолио
export const uploadPortfolio = (file: any, studentID: string, fileType: string, fileName: string) => async (dispatch: any) => {
    const responce = await api.uploadPortfolio(file, studentID, fileType, fileName)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getFiles(studentID))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Удаление файла
export const deleteFile = (fileID: number, studentID: string) => async (dispatch: any) => {
    const responce = await api.deleteFile(fileID)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getFiles(studentID))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}





// Очистка списка групп оператора
export const clearGroups = () => (dispatch: any) => {
    dispatch(actions.setGroups([]))
}

// Очистка списка студентов
export const clearStudents = () => (dispatch: any) => {
    dispatch(actions.setStudents([]))
}

// Очистка списка файлов
export const clearFiles = () => (dispatch: any) => {
    dispatch(actions.setFiles([]))
}